var map = {
	"./computer/Trade/Trade.vue": [
		"9dc3",
		"chunk-ce42bb0c"
	],
	"./mobile/Trade/Trade.vue": [
		"12c0",
		"chunk-13c68e74"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "087f";
module.exports = webpackAsyncContext;